"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationContext = void 0;
var _SiteDefinition = _interopRequireDefault(require("./SiteDefinition"));
var _ApplicationContext;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const getSessionStorage = () => {
  try {
    return window.opener && window.opener.document && window.opener.document.domain === window.document.domain ? window.opener.sessionStorage : sessionStorage;
    // eslint-disable-next-line no-empty
  } catch {}
  return sessionStorage;
};
const appStorage = getSessionStorage();

// eslint-disable-next-line import/prefer-default-export
class ApplicationContext {
  static getRouterBasename() {
    const apiRegions = process.env.API_REGIONS;
    const apiRegionList = apiRegions ? apiRegions.trim().toLowerCase().split(',') : [];
    let basename = '';
    apiRegionList.forEach(region => {
      const foundRegionInPath = window.location.pathname.match(new RegExp(`^/${region}(/?|/.*)$`));
      if (foundRegionInPath) {
        basename = region;
      }
    });
    return basename ? `/${basename}` : '';
  }
  static getRegionalApiBasePath() {
    let apiBasePath = process.env.API_BASE_URL;
    if (typeof URL === 'function' && window?.location) {
      const {
        hostname
      } = window.location;
      const hostnameParts = hostname.toLowerCase().split('.');
      const apiRegions = process.env.API_REGIONS;
      const apiRegionList = apiRegions ? apiRegions.trim().toLowerCase().split(',') : [];
      if (!apiBasePath) {
        const apiBaseUrl = new URL(window.location.href);
        apiBaseUrl.pathname = '/api';
        apiBaseUrl.search = '';
        apiBasePath = apiBaseUrl.href;
      }
      let apiBaseUrl = new URL(apiBasePath);
      let pathname = apiBaseUrl.pathname === '/' ? '' : apiBaseUrl.pathname.replace(/^\/\//, '/');
      pathname = pathname.match(/\/$/) ? pathname.replace(/\/$/, '') : pathname;
      apiBaseUrl.pathname = pathname;
      apiBasePath = apiBaseUrl.href;
      if (hostnameParts?.length > 2) {
        const subDomain = hostnameParts.shift();
        const found = subDomain.match(/[a-z0-9]+[-](?<region>[a-z0-9]+)/);
        if (found) {
          const {
            region
          } = found.groups;
          if (region) {
            if (apiRegions) {
              if (apiRegionList.includes(region)) {
                apiBaseUrl = new URL(apiBasePath);
                const apiParts = apiBaseUrl.hostname.split('.');
                if (apiParts?.length > 2) {
                  const apiSubDomain = apiParts.shift();
                  apiBaseUrl.hostname = `${apiSubDomain}-${region}.${apiParts.join('.')}`;
                  apiBasePath = apiBaseUrl.href.replace(/\/$/, '');
                }
              }
            }
          }
        } else if (hostname === apiBaseUrl.hostname) {
          const basename = ApplicationContext.getRouterBasename();
          if (basename) {
            apiBaseUrl = new URL(apiBasePath);
            pathname = apiBaseUrl.pathname === '/' ? '' : apiBaseUrl.pathname;
            pathname = pathname.match(/^\/api/) ? pathname : `/api${pathname}`;
            apiBaseUrl.pathname = `${basename}${pathname}`;
            apiBasePath = apiBaseUrl.href;
          }
        } else {
          const basename = ApplicationContext.getRouterBasename();
          if (basename) {
            apiBaseUrl = new URL(apiBasePath);
            const apiParts = apiBaseUrl.hostname.split('.');
            if (apiParts?.length > 2) {
              const apiSubDomain = apiParts.shift();
              apiBaseUrl.hostname = `${apiSubDomain}-${basename.replace(/^\//, '')}.${apiParts.join('.')}`;
              apiBasePath = apiBaseUrl.href.replace(/\/$/, '');
            }
          }
        }
      }
    }
    return apiBasePath.replace(/\/$/, '');
  }
  static getClientIdFromSearch(paramName, clientIds, matchUrl) {
    if (window && window.location.search && (!matchUrl || window.location.pathname === matchUrl) && clientIds && paramName) {
      const searchParams = new URLSearchParams(window.location.search);
      const key = searchParams.get(paramName);
      const client = clientIds.find(item => item.key === key);
      return client ? client.value : null;
    }
    return null;
  }
  static initialize(siteJSON) {
    const siteDefinition = new _SiteDefinition.default();
    const clientId = this.getClientIdFromSearch('client', siteJSON.clientIds, '/');
    siteDefinition.isClientIdSelectable = process.env.IS_CLIENT_ID_SELECTABLE || (typeof siteJSON.isClientIdSelectable !== 'undefined' ? siteJSON.isClientIdSelectable : siteDefinition.isClientIdSelectable);
    if (siteDefinition.isClientIdSelectable) {
      siteDefinition.clientId = clientId || ApplicationContext.getContext(_CLIENT_ID._) || process.env.CLIENT_ID;
    } else {
      siteDefinition.clientId = process.env.CLIENT_ID;
    }
    siteDefinition.clientIds = siteJSON.clientIds;
    siteDefinition.webSiteAreaId = process.env.SITE_ID || siteJSON.webSiteAreaId || siteDefinition.webSiteAreaId;
    siteDefinition.contactUsEmail = process.env.CONTACT_EMAIL || siteJSON.contactUsEmail || siteDefinition.contactUsEmail;
    siteDefinition.siteName = process.env.SITE_NAME || siteJSON.siteName || siteDefinition.siteName;
    siteDefinition.siteTitle = process.env.SITE_TITLE || siteJSON.siteTitle || siteDefinition.siteTitle;
    siteDefinition.siteSubTitle = process.env.SITE_SUB_TITLE || siteJSON.siteSubTitle || siteDefinition.siteSubTitle;
    siteDefinition.logo = process.env.LOGO || siteJSON.logo || siteDefinition.logo;
    siteDefinition.logoAlt = process.env.LOGO_ALT || siteJSON.logoAlt || siteDefinition.logoAlt;
    siteDefinition.welcomeTitle = process.env.SITE_WELCOME || siteJSON.welcomeTitle || siteDefinition.welcomeTitle;
    siteDefinition.siteTag = process.env.SITE_TAG || siteJSON.siteTag || siteDefinition.siteTag;
    siteDefinition.siteDescription = process.env.SITE_DESCRIPTION || siteJSON.siteDescription || siteDefinition.siteDescription;
    siteDefinition.isMultiSite = process.env.IS_MULTI_SITE || (typeof siteJSON.isMultiSite !== 'undefined' ? siteJSON.isMultiSite : siteDefinition.isMultiSite);
    siteDefinition.isMegaMenu = process.env.IS_MEGA_MENU || (typeof siteJSON.isMegaMenu !== 'undefined' ? siteJSON.isMegaMenu : siteDefinition.isMegaMenu);
    siteDefinition.gtmPathPattern = process.env.GTM_PATH_PATTERN || (typeof siteJSON.gtmPathPattern !== 'undefined' ? siteJSON.gtmPathPattern : siteDefinition.gtmPathPattern);
    siteDefinition.isPublicMegaMenu = process.env.IS_PUBLIC_MEGA_MENU || (typeof siteJSON?.public?.isMegaMenu !== 'undefined' ? siteJSON?.public?.isMegaMenu : siteDefinition.isPublicMegaMenu);
    siteDefinition.isWebUserReset = process.env.IS_WEBUSER_RESET || (typeof siteJSON.isWebUserReset !== 'undefined' ? siteJSON.isWebUserReset : siteDefinition.isWebUserReset);
    siteDefinition.isProfile = process.env.IS_PROFILE || (typeof siteJSON.isProfile !== 'undefined' ? siteJSON.isProfile : siteDefinition.isProfile);
    siteDefinition.isRunAs = process.env.IS_RUN_AS || (typeof siteJSON.isRunAs !== 'undefined' ? siteJSON.isRunAs : siteDefinition.isRunAs);
    siteDefinition.loginGreetingTitle = process.env.LOGIN_GREETING_TITLE || siteJSON.loginGreetingTitle || siteDefinition.loginGreetingTitle;
    siteDefinition.loginGreetingSubTitle = process.env.LOGIN_GREETING_SUBTITLE || siteJSON.loginGreetingSubTitle || siteDefinition.loginGreetingSubTitle;
    siteDefinition.securityCodeTitle = process.env.SECURITY_CODE_TITLE || siteJSON.securityCodeTitle || siteDefinition.securityCodeTitle;
    siteDefinition.theme = process.env.THEME || siteJSON.defaultTheme || siteDefinition.theme;
    siteDefinition.framework = process.env.FRAMEWORK || (typeof siteJSON.framework !== 'undefined' ? siteJSON.framework : siteDefinition.framework);
    siteDefinition.defaultPath = process.env.DEFAULT_PATH || siteJSON.defaultPath || siteDefinition.defaultPath;
    siteDefinition.logoutPath = process.env.LOGOUT_PATH || siteJSON.logoutPath || siteDefinition.logoutPath;
    siteDefinition.loginPath = process.env.LOGIN_PATH || siteJSON.loginPath || siteDefinition.loginPath;
    siteDefinition.notFoundPath = process.env.NOT_FOUND_PATH || siteJSON.notFoundPath || siteDefinition.notFoundPath;
    siteDefinition.defaultLoginMethod = process.env.DEFAULT_LOGIN_METHOD || siteJSON.defaultLoginMethod;
    siteDefinition.headerShowTitleExternal = process.env.HEADER_SHOW_TITLE_EXTERNAL || (typeof siteJSON.headerShowTitleExternal !== 'undefined' ? siteJSON.headerShowTitleExternal : siteDefinition.headerShowTitleExternal);
    siteDefinition.breadcrumb = process.env.BREADCRUMB || siteJSON.breadcrumb || siteDefinition.breadcrumb;
    siteDefinition.public = process.env.PUBLIC_SITE && process.env.PUBLIC_SITE.length > 0 ? JSON.parse(process.env.PUBLIC_SITE) : siteJSON.public;
    _PRIMARY_SITE_DEFINITION._ = _assertClassBrand(ApplicationContext, this, siteDefinition);
    _ALTERNATE_SITE_DEFINITIONS._ = _assertClassBrand(ApplicationContext, this, []);
    if (siteJSON.alternateSiteConfigurations) {
      siteJSON.alternateSiteConfigurations.forEach(alternate => {
        const alternateDefinition = {
          ...siteDefinition
        };
        Object.keys(alternate).forEach(key => {
          alternateDefinition[key] = alternate[key];
        });
        _assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITIONS)._.push(alternateDefinition);
      });
    }
    ApplicationContext.setContext(_SITE_INACTIVE_TIMEOUT._, process.env.SITE_INACTIVE_TIMEOUT || siteJSON.siteInactiveTimeout || '18');
    ApplicationContext.setContext(_API_BASE_URL._, ApplicationContext.getRegionalApiBasePath());
    ApplicationContext.setContext(_RECAPTCHA_SITE_KEY._, process.env.RECAPTCHA_SITE_KEY || siteJSON.recaptchaSiteKey);
    ApplicationContext.setContext(_IS_LAUNCH_TOKEN._, process.env.IS_LAUNCH_TOKEN || siteJSON.isLaunchToken || false);
    ApplicationContext.setContext(_IS_AUTO_INITIATE_LOGIN._, process.env.IS_AUTO_INITIATE_LOGIN || siteJSON.isAutoInitiateLogin || false);
    ApplicationContext.setContext(_DEFAULT_LOGIN_METHOD._, process.env.DEFAULT_LOGIN_METHOD || siteJSON.defaultLoginMethod);
    ApplicationContext.setContext(_IS_RETURN_URL._, process.env.IS_RETURN_URL || siteJSON.isReturnUrl || true);
    ApplicationContext.setContext(_IS_MARKETING_REP._, process.env.IS_MARKETING_REP || siteJSON.isMarketingRep || false);
    ApplicationContext.setContext(_LEGAL_INTENDED_AUDIENCE._, process.env.LEGAL_INTENDED_AUDIENCE || siteJSON.legalIntendedAudience);
    ApplicationContext.setContext(_LEGAL_NOT_INTENDED_AUDIENCE._, process.env.LEGAL_NOT_INTENDED_AUDIENCE || siteJSON.legalNotIntendedAudience);
    ApplicationContext.setContext(_IS_LOGIN_DATA_SERVICE._, process.env.IS_LOGIN_DATA_SERVICE || siteJSON.isLoginDataService || false);
    ApplicationContext.setContext(_DATASOURCE._, process.env.DATASOURCE || siteJSON.dataSource);
    if (process.env.TRANSITION === 'Y' || siteJSON.transition === 'Y') {
      ApplicationContext.setContext(_DATASOURCE._, 'SSNC');
    }
    ApplicationContext.setContext(_TRANSITION._, process.env.TRANSITION || siteJSON.transition);
    ApplicationContext.setContext(_GTM_ID._, process.env.GTM_ID);
    ApplicationContext.setContext(_GTM_ROUTE_AREAS._, process.env.GTM_ROUTE_AREAS);
  }
  static hasSiteDefinitionChanged(path) {
    let nextSiteDefinition = null;
    _assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITIONS)._.forEach(alternate => {
      const pathPattern = new RegExp(alternate.pathPattern);
      if (pathPattern.test(path)) {
        nextSiteDefinition = alternate;
      }
    });
    let isChanged = false;
    if (_assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITION)._ === null && nextSiteDefinition === null) {
      // Nothing has changed
    } else if (_assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITION)._ !== null && nextSiteDefinition !== null && _assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITION)._.pathPattern === nextSiteDefinition?.pathPattern) {
      // Nothing has changed
    } else {
      _ALTERNATE_SITE_DEFINITION._ = _assertClassBrand(ApplicationContext, this, nextSiteDefinition);
      isChanged = true;
    }
    return isChanged;
  }
  static getSiteDefinition() {
    if (_assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITION)._ !== null) {
      return _assertClassBrand(ApplicationContext, this, _ALTERNATE_SITE_DEFINITION)._;
    }
    return _assertClassBrand(ApplicationContext, this, _PRIMARY_SITE_DEFINITION)._;
  }
  static getDefaultPath() {
    return this.getSiteDefinition().defaultPath;
  }
  static getLoginPath() {
    return this.getSiteDefinition().loginPath;
  }
  static getLogoutPath() {
    return this.getSiteDefinition().logoutPath;
  }
  static getNotFoundPath() {
    return this.getSiteDefinition().notFoundPath;
  }
  static getProfilePath() {
    return this.getSiteDefinition().profilePath;
  }
  static getHeaderShowTitleExternal() {
    return this.getSiteDefinition().headerShowTitleExternal;
  }
  static getSiteId() {
    return this.getSiteDefinition().siteId;
  }
  static getContactEmail() {
    return this.getSiteDefinition().contactUsEmail;
  }
  static getShowFramework() {
    return this.getSiteDefinition().framework;
  }
  static getSiteName() {
    return this.getSiteDefinition().siteName;
  }
  static getSiteTitle() {
    return this.getSiteDefinition().siteTitle;
  }
  static getSiteSubTitle() {
    return this.getSiteDefinition().siteSubTitle;
  }
  static getLoginGreetingTitle() {
    return this.getSiteDefinition().loginGreetingTitle;
  }
  static getLoginGreetingSubTitle() {
    return this.getSiteDefinition().loginGreetingSubTitle;
  }
  static getSecurityCodeTitle() {
    return this.getSiteDefinition().securityCodeTitle;
  }
  static getSiteWelcome() {
    return this.getSiteDefinition().welcomeTitle;
  }
  static getSiteTag() {
    return this.getSiteDefinition().siteTag;
  }
  static getSiteDescription() {
    return this.getSiteDefinition().siteDescription;
  }
  static getRecaptchaSiteKey() {
    return ApplicationContext.getContext(_RECAPTCHA_SITE_KEY._, '') !== 'undefined' ? ApplicationContext.getContext(_RECAPTCHA_SITE_KEY._, '') : null;
  }
  static getSiteInactiveTimeout() {
    return Number(ApplicationContext.getContext(_SITE_INACTIVE_TIMEOUT._, '18'));
  }
  static getApiBasePath() {
    return ApplicationContext.getContext(_API_BASE_URL._);
  }
  static getClientId() {
    return this.getSiteDefinition().clientId;
  }
  static setClientId(clientId) {
    this.getSiteDefinition().clientId = clientId;
    ApplicationContext.setContext(_CLIENT_ID._, clientId);
  }
  static setClient(key) {
    if (this.getSiteDefinition().clientIds) {
      const client = this.getSiteDefinition().clientIds.filter(item => item.key === key);
      if (client) {
        this.setClientId(client.value);
      }
    }
  }
  static setClientIdFromParam(paramName) {
    const clientId = this.getClientIdFromSearch(paramName, this.getSiteDefinition().clientIds);
    if (clientId && this.getSiteDefinition().isClientIdSelectable) {
      this.setClientId(clientId);
    }
  }
  static getClientIds() {
    return this.getSiteDefinition().clientIds;
  }
  static isMegaMenu() {
    return this.getSiteDefinition().isMegaMenu;
  }
  static isPublicMegaMenu() {
    return this.getSiteDefinition().isPublicMegaMenu;
  }
  static isMultiSite() {
    return this.getSiteDefinition().isMultiSite;
  }
  static isWebUserReset() {
    return this.getSiteDefinition().isWebUserReset;
  }
  static isLaunchToken() {
    return ApplicationContext.getContext(_IS_LAUNCH_TOKEN._, false) === 'true';
  }
  static isAutoInitiateLogin() {
    return ApplicationContext.getContext(_IS_AUTO_INITIATE_LOGIN._, false) === 'true';
  }
  static getDefaultLoginMethod() {
    return this.getSiteDefinition().defaultLoginMethod;
  }
  static isProfile() {
    return this.getSiteDefinition().isProfile;
  }
  static isRunAs() {
    return this.getSiteDefinition().isRunAs;
  }
  static isMarketingRep() {
    return ApplicationContext.getContext(_IS_MARKETING_REP._, false) === 'true';
  }
  static isReturnUrl() {
    return ApplicationContext.getContext(_IS_RETURN_URL._, true) === 'true';
  }
  static getLegalIntendedAudience() {
    return ApplicationContext.getContext(_LEGAL_INTENDED_AUDIENCE._);
  }
  static getLegalNotIntendedAudience() {
    return ApplicationContext.getContext(_LEGAL_NOT_INTENDED_AUDIENCE._);
  }
  static setTheme(theme) {
    ApplicationContext.setContext(_THEME._, theme);
  }
  static getTheme() {
    let theme = ApplicationContext.getContext(_THEME._);
    if (theme && theme.length === 0) {
      theme = undefined;
    }
    const themeName = this.getApplicationPreference('htmlClassReference');
    return theme || themeName || this.getSiteDefinition().theme;
  }
  static getThemeCss() {
    return this.getApplicationPreference('cascadingStyleSheet');
  }
  static getLogo() {
    const defaultLogo = _assertClassBrand(ApplicationContext, this, _getDefaultApplicationPreference).call(this, 'bannerImageLocation');
    const customLogo = ApplicationContext.getTheme() ? this.getSiteDefinition().logo || this.getApplicationPreference('bannerImageLocation') : undefined;
    if (defaultLogo === customLogo) {
      return undefined;
    }
    return customLogo;
  }
  static getLogoAlt() {
    return ApplicationContext.getTheme() ? this.getSiteDefinition().logoAlt || this.getApplicationPreference('bannerImageAlt') : null;
  }
  static getOverrideDefaultPath() {
    return ApplicationContext.getContext(_OVERRIDE_DEFAULT_PATH._, '') && ApplicationContext.getContext(_OVERRIDE_DEFAULT_PATH._, '') !== 'undefined' ? ApplicationContext.getContext(_OVERRIDE_DEFAULT_PATH._, '') : null;
  }
  static setOverrideDefaultPath(overrideDefaultPath) {
    ApplicationContext.setContext(_OVERRIDE_DEFAULT_PATH._, overrideDefaultPath);
  }
  static isLoginDataService() {
    return ApplicationContext.getContext(_IS_LOGIN_DATA_SERVICE._, false) === 'true';
  }
  static getDataSource() {
    const dataSource = ApplicationContext.getContext(_DATASOURCE._, null) !== 'undefined' ? ApplicationContext.getContext(_DATASOURCE._, null) : null;
    const overrideDataSource = ApplicationContext.getContext(_OVERRIDE_DATASOURCE._, null) !== 'undefined' ? ApplicationContext.getContext(_OVERRIDE_DATASOURCE._, null) : null;
    return overrideDataSource || dataSource;
  }
  static getTransition() {
    return ApplicationContext.getContext(_TRANSITION._, null) !== 'undefined' ? ApplicationContext.getContext(_TRANSITION._, null) : null;
  }
  static setDataSource(dataSource) {
    ApplicationContext.setContext(_OVERRIDE_DATASOURCE._, dataSource);
  }
  static getGoogleTagManagerId() {
    return ApplicationContext.getContext(_GTM_ID._, null) !== 'undefined' ? ApplicationContext.getContext(_GTM_ID._, null) : null;
  }
  static getGoogleTagManagerRouteAreas() {
    return ApplicationContext.getContext(_GTM_ROUTE_AREAS._, null) !== 'undefined' ? ApplicationContext.getContext(_GTM_ROUTE_AREAS._, null) : null;
  }
  static getGoogleTagManagerPathPattern() {
    return this.getSiteDefinition().gtmPathPattern;
  }
  static setAzureApplicationId(azureApplicationId) {
    ApplicationContext.setContext(_AZURE_APPLICATION_ID._, azureApplicationId);
  }
  static getAzureApplicationId() {
    return ApplicationContext.getContext(_AZURE_APPLICATION_ID._, null) !== 'undefined' && ApplicationContext.getContext(_AZURE_APPLICATION_ID._, null) !== 'null' ? ApplicationContext.getContext(_AZURE_APPLICATION_ID._, null) : null;
  }
  static setAzureTenantId(azureTenantId) {
    ApplicationContext.setContext(_AZURE_TENANT_ID._, azureTenantId);
  }
  static getAzureTenantId() {
    return ApplicationContext.getContext(_AZURE_TENANT_ID._, null) !== 'undefined' && ApplicationContext.getContext(_AZURE_TENANT_ID._, null) !== 'null' ? ApplicationContext.getContext(_AZURE_TENANT_ID._, null) : null;
  }
  static setDefaultApplicationPreferences(applicationPreferences) {
    ApplicationContext.setContext(_DEFAULT_APPLICATION_PREFERENCES_ID._, JSON.stringify(applicationPreferences));
    const event = new CustomEvent('applicationPreferencesUpdated');
    window.dispatchEvent(event);
  }
  static getDefaultApplicationPreferences() {
    const applicationPreferences = ApplicationContext.getContext(_DEFAULT_APPLICATION_PREFERENCES_ID._, null);
    return applicationPreferences !== 'undefined' ? JSON.parse(applicationPreferences) : null;
  }
  static setCurrentApplicationPreferences(applicationPreferences) {
    ApplicationContext.setContext(_CURRENT_APPLICATION_PREFERENCES_ID._, JSON.stringify(applicationPreferences));
    const event = new CustomEvent('applicationPreferencesUpdated');
    window.dispatchEvent(event);
  }
  static getCurrentApplicationPreferences() {
    const applicationPreferences = ApplicationContext.getContext(_CURRENT_APPLICATION_PREFERENCES_ID._, null);
    return applicationPreferences && applicationPreferences !== 'undefined' && applicationPreferences !== 'null' ? JSON.parse(applicationPreferences) : ApplicationContext.getDefaultApplicationPreferences();
  }
  static getApplicationPreference(preferenceName) {
    const prefValue = _assertClassBrand(ApplicationContext, this, _getCurrentApplicationPreference).call(this, preferenceName);
    if (prefValue && prefValue !== 'null') {
      return prefValue;
    }
    return _assertClassBrand(ApplicationContext, this, _getDefaultApplicationPreference).call(this, preferenceName);
  }
  static setClientAuthConfiguration(clientId, authConfiguration) {
    ApplicationContext.setContext(`APPL_CTXT.AUTH_CONFIGURATION_${clientId}`, JSON.stringify(authConfiguration));
  }
  static getClientAuthConfiguration(clientId) {
    const authConfiguration = ApplicationContext.getContext(`APPL_CTXT.AUTH_CONFIGURATION_${clientId}`, null);
    return authConfiguration !== 'undefined' ? JSON.parse(authConfiguration) : null;
  }
  static showFramework(visible) {
    window.postMessage(`{"showFramework": ${visible}}`, window.location.origin);
  }
}
exports.ApplicationContext = ApplicationContext;
_ApplicationContext = ApplicationContext;
function _getCurrentApplicationPreference(preferenceName) {
  const applicationPreferences = _ApplicationContext.getCurrentApplicationPreferences();
  if (!applicationPreferences?.preferences) {
    return null;
  }
  const map = new Map(applicationPreferences.preferences.map(i => [i.name, i.value]));
  return map === null ? null : map.get(preferenceName);
}
function _getDefaultApplicationPreference(preferenceName) {
  const applicationPreferences = _ApplicationContext.getDefaultApplicationPreferences();
  if (!applicationPreferences?.preferences) {
    return null;
  }
  const map = new Map(applicationPreferences.preferences.map(i => [i.name, i.value]));
  return map === null ? null : map.get(preferenceName);
}
var _SITE_ID_KEY = {
  _: 'APPL_CTXT.SITE_ID'
};
var _DEFAULT_LOGIN_METHOD = {
  _: 'APPL_CTXT.DEFAULT_LOGIN_METHOD'
};
var _CONTACT_EMAIL_KEY = {
  _: 'APPL_CTXT.CONTACT_EMAIL'
};
var _SITE_NAME_KEY = {
  _: 'APPL_CTXT.SITE_NAME'
};
var _SITE_TITLE_KEY = {
  _: 'APPL_CTXT.SITE_TITLE'
};
var _SITE_SUB_TITLE_KEY = {
  _: 'APPL_CTXT.SITE_SUB_TITLE'
};
var _SITE_WELCOME_KEY = {
  _: 'APPL_CTXT.SITE_WELCOME'
};
var _SITE_TAG_KEY = {
  _: 'APPL_CTXT.SITE_TAG'
};
var _SITE_DESCRIPTION_KEY = {
  _: 'APPL_CTXT.SITE_DESCRIPTION'
};
var _SITE_INACTIVE_TIMEOUT = {
  _: 'APPL_CTXT.INACTIVE_TIMEOUT'
};
var _API_BASE_URL = {
  _: 'APPL_CTXT.API_BASE_URL'
};
var _CLIENT_ID = {
  _: 'APPL_CTXT.CLIENT_ID'
};
var _IS_CLIENT_ID_SELECTABLE = {
  _: 'APPL_CTXT.IS_CLIENT_ID_SELECTABLE'
};
var _RECAPTCHA_SITE_KEY = {
  _: 'APPL_CTXT.RECAPTCHA_SITE_KEY'
};
var _IS_MEGA_MENU = {
  _: 'APPL_CTXT.IS_MEGA_MENU'
};
var _IS_PUBLIC_MEGA_MENU = {
  _: 'APPL_CTXT.IS_PUBLIC_MEGA_MENU'
};
var _IS_MULTI_SITE = {
  _: 'APPL_CTXT.IS_MULTI_SITE'
};
var _IS_WEBUSER_RESET = {
  _: 'APPL_CTXT.IS_WEBUSER_RESET'
};
var _IS_LAUNCH_TOKEN = {
  _: 'APPL_CTXT.IS_LAUNCH_TOKEN'
};
var _IS_AUTO_INITIATE_LOGIN = {
  _: 'APPL_CTXT.IS_AUTO_INITIATE_LOGIN'
};
var _IS_PROFILE = {
  _: 'APPL_CTXT.IS_PROFILE'
};
var _IS_RUN_AS = {
  _: 'APPL_CTXT.IS_RUN_AS'
};
var _IS_MARKETING_REP = {
  _: 'APPL_CTXT.IS_MARKETING_REP'
};
var _LEGAL_INTENDED_AUDIENCE = {
  _: 'APPL_CTXT.LEGAL_INTENDED_AUDIENCE'
};
var _LEGAL_NOT_INTENDED_AUDIENCE = {
  _: 'APPL_CTXT.LEGAL_NOT_INTENDED_AUDIENCE'
};
var _LOGIN_GREETING_TITLE = {
  _: 'APPL_CTXT.LOGIN_GREETING_TITLE'
};
var _LOGIN_GREETING_SUBTITLE = {
  _: 'APPL_CTXT.LOGIN_GREETING_SUBTITLE'
};
var _THEME = {
  _: 'APPL_CTXT.THEME'
};
var _OVERRIDE_DEFAULT_PATH = {
  _: 'APPL_CTXT.OVERRIDE_DEFAULT_PATH'
};
var _IS_LOGIN_DATA_SERVICE = {
  _: 'APPL_CTXT.IS_LOGIN_DATA_SERVICE'
};
var _DATASOURCE = {
  _: 'APPL_CTXT.DATASOURCE'
};
var _OVERRIDE_DATASOURCE = {
  _: 'APPL_CTXT.OVERRIDE_DATASOURCE'
};
var _TRANSITION = {
  _: 'APPL_CTXT.TRANSITION'
};
var _GTM_ID = {
  _: 'APPL_CTXT.GTM_ID'
};
var _GTM_ROUTE_AREAS = {
  _: 'APPL_CTXT.GTM_ROUTE_AREAS'
};
var _IS_RETURN_URL = {
  _: 'APPL_CTXT.IS_RETURN_URL'
};
var _AZURE_APPLICATION_ID = {
  _: 'APPL_CTXT.AZURE_APPLICATION_ID'
};
var _AZURE_TENANT_ID = {
  _: 'APPL_CTXT.AZURE_TENANT_ID'
};
var _SITE_DEFINITION_ID = {
  _: 'APPL_CTXT.SITE_DEFINITION_ID'
};
var _DEFAULT_APPLICATION_PREFERENCES_ID = {
  _: 'APPL_CTXT.DEFAULT_APPLICATION_PREFERENCES_ID'
};
var _CURRENT_APPLICATION_PREFERENCES_ID = {
  _: 'APPL_CTXT.CURRENT_APPLICATION_PREFERENCES_ID'
};
var _PRIMARY_SITE_DEFINITION = {
  _: new _SiteDefinition.default()
};
var _ALTERNATE_SITE_DEFINITION = {
  _: null
};
var _ALTERNATE_SITE_DEFINITIONS = {
  _: []
};
/**
 * Adds a key value pair to the application context
 * @param {string} key
 * @param {string} value
 * @example
 *  ApplicationContext.setContext('selectedPlan', '333333');
 */
_defineProperty(ApplicationContext, "setContext", (key, value) => {
  appStorage.setItem(key, value);
});
/**
 * Gets a variable value from the application context
 * @param {string} key
 * @param {string} defaultValue
 * @returns The value stored in the application context
 */
_defineProperty(ApplicationContext, "getContext", (key, defaultValue) => {
  const value = appStorage.getItem(key);
  return value || defaultValue;
});
_defineProperty(ApplicationContext, "clearContext", siteJSON => {
  if (siteJSON) {
    appStorage.clear();
    _ApplicationContext.initialize(siteJSON);
  } else {
    const itemsToRemove = [];
    for (let i = 0; i < appStorage.length; i++) {
      const itemName = appStorage.key(i);
      if (!itemName.startsWith('APPL_CTXT')) {
        itemsToRemove.push(itemName);
      }
    }
    itemsToRemove.forEach(itemName => appStorage.removeItem(itemName));
  }
  appStorage.removeItem(_OVERRIDE_DATASOURCE._);
});
//# sourceMappingURL=ApplicationContext.js.map